import { IconStar } from '@src/assets/icon-star';
import type { SubscriptionPageFeeback } from '@src/lib/graphql/generated';
import { Image, type PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const ReviewCard = ({
  name,
  position,
  text,
  stars,
  image,
  classProps,
}: SubscriptionPageFeeback & PropsWithClassProps) => {
  const staricons = Array.from({ length: stars ?? 5 }).map((_, index) => (
    <IconStar key={index} filled classProps={{ root: 'text-primary mr-1' }} />
  ));

  return (
    <div
      className={twMerge(
        'card-gradient max-w-[30rem] rounded-2xl border border-gray-650/65 px-4 py-6 text-white',
        classProps?.root,
      )}
    >
      {staricons}
      <div className="py-4 text-xl" dangerouslySetInnerHTML={{ __html: text }} />
      <div className="flex items-center">
        <div className="relative size-20 overflow-hidden rounded-full">
          {image && (
            <Image
              src={image.url}
              alt={image.alt || ''}
              copyright={image.copyright_text}
              fill
              imageMode="cover"
              className="rounded-full"
              sizes="160px"
            />
          )}
        </div>
        <div className="ml-2">
          <div className="font-bold text-base">{name}</div>
          <div className="text-gray-500 text-label-sm uppercase">{position}</div>
        </div>
      </div>
    </div>
  );
};
